import { Permiso } from './../../../../_entities/Enums/permiso.enum';
import { Router } from '@angular/router';
import { ModeloDispositivoService } from './../../services/modelo-dispositivo.service';
import { ListaModelos } from './../../../../_entities/dispositivos/AgregarDispositivoVM';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'kt-modelo-dispositivo',
  templateUrl: './modelo-dispositivo.component.html',
  styleUrls: ['./modelo-dispositivo.component.scss']
})
export class ModeloDispositivoComponent implements OnInit {
  @ViewChild('gridContainer', { static: false }) gridContainer: ElementRef;
  
  public modeloRegistros: ListaModelos[];
  public showFilterRow: boolean;
  public showHeaderFilter: boolean;

  public permisoConsultarModelosDispositivos: string;
  public permisoAgregarModeloDispositivo: string;
  public permisoActualizarModeloDispositivo: string;
  public permisoEliminarModeloDispositivo: string;

  constructor(private modeloDispositivoService: ModeloDispositivoService,
    private router: Router) { }

  ngOnInit() {
    this.obtenerModelos();
    this.obtenerPermisosModelosDispositivos();
  }

  obtenerModelos() {
    this.modeloDispositivoService.obtenerModelos().subscribe(
      (res: ListaModelos[]) => {
        this.modeloRegistros = res;
    }, (err) => { console.log('Error al obtener los modelos', err) });
  }

  altaModeloDispositivo(){
    this.router.navigateByUrl('/home/administracion/dispositivos/modelo/alta');
  }

  editarModeloDispositivo(idModelo) {
    this.router.navigateByUrl('/home/administracion/dispositivos/modelo/editar/' + idModelo);
  }

  eliminarModelo(data) {
    Swal.fire({
      title: 'Eliminar',
      text: `¿Está seguro que desea eliminar el modelo ` + data.nombre,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.value) {
        this.modeloDispositivoService.eliminarModelo(data.id).subscribe(res => {
          Swal.fire(
            'Eliminado!',
            'El modelo ha sido eliminado.',
            'success'
          );
          this.ngOnInit();
        }, err => {
          Swal.fire(
            'Ops!',
            'Error al intentar eliminar el modelo del dispositivo.',
            'error'
          );
        });
      }
    })
  }

  
  /**Obtener permisos para Modelos Dispositivos */
  public get Permiso() {
    return Permiso;
  }

  obtenerPermisosModelosDispositivos() {
    this.permisoConsultarModelosDispositivos = Permiso.ConsultarModelosDispositivos;
    this.permisoAgregarModeloDispositivo = Permiso.AgregarModeloDispositivo;
    this.permisoActualizarModeloDispositivo = Permiso.ActualizarModeloDispositivo;
    this.permisoEliminarModeloDispositivo = Permiso.EliminarModeloDispositivo;
  }

}
